import { useState, useEffect } from 'react';
import API from '../../utils/apiCalling';
import { saveAs, FileSaver } from 'file-saver';
import { useLocation, useParams } from "react-router-dom";
import Config from '../../config/env'

// import FileSaver from 'file-saver';


const DownloadArtifactsByResponseId = () => {
  let api = new API()
  const { id } = useParams();
  const [image, setImage] = useState([])
  const [responseId, SetResponseId] = useState('')
  const [secondsearch, setSecondSearch] = useState('')

  useEffect(() => {
    // getImage()
  }, [])



  const getImage = async () => {
    try{
    let result
    console.log(id, "idddddddddddd")
   
      const response = await api.postwithblob(`${Config.new.site_api}/client-survey/downloadSurveyAttachments`, { surveyId: id ,rId:responseId},
    {
        responseType: 'blob'
      });
      console.log(response,"response.data")
      const blob = new Blob([response], { type: 'application/zip' });

      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'images.zip';
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      // setLoading(false);
    }
  }
  const secondImage = async () => {
    let data = {
      ImageArray: JSON.stringify(image),
      searchValue: secondsearch
    }
    let result = await api.post(`${Config.new.site_api}/Avanti/searchImagetwo`, data)
    if (result.code === 200) {
      setImage(result.data)
    }
  }



  const handleDownload = (e) => {
    if (id === undefined) {
      saveAs(e.Image, e.Id)
    } else {
      saveAs(e.image, e.ID)
    }
  }


  return (
    <>
        <section id="all-section" className="admin-header position-relative">

      <nav className="navbar navbar-expand-lg bg-white p-0 border border-bottom" style={{ height: "80px" }}>
        <div className="container-fluid ">
          <a className="navbar-brand1 logo-itemsw logoMain" href="#" target="break"><img src={"../images/new-logo.png"} alt="" style={{ height: "70px", margin: "5px" }} /></a>
          
          <ul className="navbar-nav flex-row align-items-center justify-contents-center w-auto">
          </ul>
        </div>

      </nav>
    </section>
      <div className='col-lg-12 '>
        <div className="container">
      <div className="row align-items-center">
        <div className="col-md-1">
          <label>Response ID</label>
        </div>
        <div className="col-md-5">
          <input
            type="text"
            className="form-control"
            // value={startDate}
             onChange={e=>SetResponseId(e.target.value)}
          />
        </div>
       <div className="container ">
      <button className="btn btn-primary w-100 " onClick={getImage}>Download All</button>
    </div>
      </div>
    </div>
        <div className='d-flex flex-wrap justify-content-center'>
          {image && image?.map((e) => {
            return (
              <div className='card ContentTap1 m-1' >
                {/* {/ <button><i className="bi bi-three-dots-vertical" ></i></button> /} */}
                <div className='UnnderItems text-center' >

                  {/* {/ <h4 className='text-orange mb-1'>e.survey_name</h4> /} */}
                  {id === undefined ? <><video src={e.Image} alt='Img' height={180} width={240} />
                    <p className='mb-0'>Dealer Name <span>: {e.Id}</span></p></>
                    : <>
                      {/* <img src={e.image} alt='Img' height={180} width={240} loading='lazy' /> */}
                      <p className='mb-0'>Id <span>: {e.ID}</span></p></>}
                  <p className='mb-0 text-orange' onClick={(q) => handleDownload(e)} style={{ cursor: 'pointer' }}>Download </p>
                </div>
                <div className='UnnderItems UnderSamers h-100'>
                </div>
              </div>)
          })}
        </div>
      </div>
    </>
  );
}

export default DownloadArtifactsByResponseId;